import React, { useState } from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import { toast } from 'react-toastify';
import { MASK_CPF } from '~/constant';
import { cpfSchema } from '~/validationSchemas';

const inicial = { nome: '', cpf: '', percentualParticipacao: '' };

const normalizarPercentual = value => {
  let valor = (value || '').replace(',', '.').replace(/[^0-9.]/g, '');
  const partes = valor.split('.');

  if (partes.length > 2) {
    valor = `${partes[0]}.${partes.slice(1).join('')}`;
  }

  const [inteiro, decimal] = valor.split('.');
  const inteiroLimitado = (inteiro || '').slice(0, 3);
  const decimalLimitado = decimal !== undefined ? decimal.slice(0, 2) : undefined;
  const percentual = decimalLimitado !== undefined
    ? `${inteiroLimitado}.${decimalLimitado}`
    : inteiroLimitado;

  if (Number(percentual) > 100) return '100';
  return percentual;
};

const ModalAddSocio = ({ show, onHide, onAdicionar, socio }) => {
  const ehEdicao = !!socio;
  const [form, setForm] = useState(socio || inicial);
  const [erros, setErros] = useState({});

  React.useEffect(() => {
    setForm(socio || inicial);
    setErros({});
  }, [socio, show]);

  const alterar = event => {
    const { name, value } = event.target;
    const valor = name === 'percentualParticipacao'
      ? normalizarPercentual(value)
      : value;
    setForm(atual => ({ ...atual, [name]: valor }));
    setErros(atuais => ({ ...atuais, [name]: null }));
  };

  const validar = () => {
    const novosErros = {};

    if (!form.nome || !form.nome.trim()) {
      novosErros.nome = 'Nome deve ser preenchido.';
    }

    try {
      cpfSchema.validateSync(form.cpf);
    } catch (err) {
      novosErros.cpf = err.message;
    }

    const percentual = Number(String(form.percentualParticipacao).replace(',', '.'));
    if (!form.percentualParticipacao || percentual <= 0 || percentual > 100) {
      novosErros.percentualParticipacao = 'Percentual deve estar entre 0,01 e 100.';
    } else if (!/^\d{1,3}(\.\d{1,2})?$/.test(String(form.percentualParticipacao))) {
      novosErros.percentualParticipacao = 'Percentual deve ter no máximo 2 casas decimais.';
    }

    return novosErros;
  };

  const salvar = async () => {
    try {
      const novosErros = validar();
      if (Object.keys(novosErros).length) {
        setErros(novosErros);
        throw new Error('Preencha os campos obrigatórios.');
      }

      const percentual = Number(String(form.percentualParticipacao).replace(',', '.'));
      onAdicionar({
        ...form,
        cpf: form.cpf.replace(/\D/g, ''),
        percentualParticipacao: Number(percentual.toFixed(2)),
      });
      onHide();
    } catch (err) {
      toast.error(err.message || 'Dados do sócio inválidos.');
    }
  };

  const RequiredLabel = ({ children }) => (
    <Form.Label>
      {children}
      <span className="hpj-required">*</span>
    </Form.Label>
  );

  const FieldError = ({ name }) => (
    erros[name] ? <div className="hpj-field-error">{erros[name]}</div> : null
  );

  return (
    <Modal className="hpj-modal hpj-modal-socio" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{ehEdicao ? 'Editar Sócio' : 'Adicionar Sócio'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col md={6}>
            <Form.Group className={erros.nome ? 'has-error' : ''}>
              <RequiredLabel>Nome</RequiredLabel>
              <Form.Control name="nome" value={form.nome} onChange={alterar} maxLength={150} />
              <FieldError name="nome" />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className={erros.cpf ? 'has-error' : ''}>
              <RequiredLabel>CPF</RequiredLabel>
              <MaskedInput
                className="form-control"
                guide={false}
                inputMode="numeric"
                mask={MASK_CPF}
                name="cpf"
                onChange={alterar}
                placeholder="000.000.000-00"
                showMask={false}
                value={form.cpf}
              />
              <FieldError name="cpf" />
            </Form.Group>
          </Col>
          <Col md={2}>
            <Form.Group className={erros.percentualParticipacao ? 'has-error' : ''}>
              <RequiredLabel>%</RequiredLabel>
              <Form.Control
                inputMode="decimal"
                max="100"
                name="percentualParticipacao"
                placeholder="0,00"
                step="0.01"
                type="text"
                value={form.percentualParticipacao}
                onChange={alterar}
              />
              <FieldError name="percentualParticipacao" />
            </Form.Group>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button className="hpj-btn" variant="outline-secondary" onClick={onHide}>Cancelar</Button>
        <Button className="hpj-btn hpj-btn-primary" variant="primary" onClick={salvar}>
          {ehEdicao ? 'Salvar' : 'Adicionar'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalAddSocio;
